/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.gwc_updateCartByCheckout = exports.CustomEvent = exports.gwc_find = exports.gwc_attr = exports.gwc_parent = exports.gwc_on = exports.gwc_delegate = exports.gwc_qsa = exports.gwc_qs = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

__webpack_require__(2);

__webpack_require__(3);

exports.gwc_qs = gwc_qs;
exports.gwc_qsa = gwc_qsa;
exports.gwc_delegate = gwc_delegate;
exports.gwc_on = gwc_on;
exports.gwc_parent = gwc_parent;
exports.gwc_attr = gwc_attr;
exports.gwc_find = gwc_find;
exports.CustomEvent = CustomEvent;
exports.gwc_updateCartByCheckout = gwc_updateCartByCheckout;


// Get element using the selector.
function gwc_qs(selector, scope) {
    return (scope || document).querySelector(selector);
}

// Get all the selector.
function gwc_qsa(selector, scope) {
    return (scope || document).querySelectorAll(selector);
}

// addEventListener wrapper:
function gwc_on(target, type, callback, useCapture) {
    target.addEventListener(type, callback, !!useCapture);
}

// Attach a handler to event for all elements that match the selector, now or in
// the future, based on a root element
function gwc_delegate(target, selector, type, handler) {
    var useCapture = type === 'blur' || type === 'focus';
    gwc_on(target, type, dispatchEvent, useCapture);

    function dispatchEvent(event) {

        var targetElement = event.target;
        var potentialElements = gwc_qsa(selector, target);
        var hasMatch = Array.prototype.indexOf.call(potentialElements, targetElement) >= 0;

        if (hasMatch) {
            handler.call(targetElement, event);
        }
    }
}

// Get the parent of the element.
function gwc_parent(element, tagName) {
    if (!element.parentNode) {
        return undefined;
    }
    if (element.parentNode.tagName.toLowerCase() === tagName.toLowerCase()) {
        return element.parentNode;
    }
    return gwc_parent(element.parentNode, tagName);
}

/**
 * Find the child element.
 *
 * @since 1.0.0
 *
 * @param {Object} element
 * @param {string} className
 */
function gwc_find(element, className) {
    var child_node = void 0;

    if (!element.childNodes) {
        child_node = undefined;
    }

    Array.from(element.childNodes).forEach(function (child) {
        if (undefined === child.classList) {
            return;
        }

        if (child.classList.contains(className)) {
            child_node = child;
        }
    });

    return child_node;
}

/**
 * Get the attribute from the selector.
 *
 * @since 1.0.0
 *
 * @param {int} form_id
 * @param {string} attr
 */
function gwc_attr(form_id, attr) {
    attr = attr || '';
    var form = gwc_qs('#give-wc-form-' + form_id);

    return null !== form ? form.getAttribute('data-' + attr) : false;
}

/**
 * IE Support
 *
 * @param {*} event
 * @param {*} params
 */
function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
}

/**
 * If user forgot to click on the "Update Cart" button and direct
 * click on the "Proceed to checkout" button then append the selected
 * Give Donations to the Cart.
 *
 * https://github.com/impress-org/give-donation-upsells-woocommerce/issues/24
 *
 * @since 1.0.0
 *
 * @param {*} action
 * @param {*} formElement
 * @param {string} method
 */
function gwc_updateCartByCheckout(action, formElement) {
    var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'POST';


    if (null === formElement) {
        return;
    }

    var formData = new FormData(formElement),
        convertedJSON = {};

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref = _step.value;

            var _ref2 = _slicedToArray(_ref, 2);

            var key = _ref2[0];
            var value = _ref2[1];

            convertedJSON[key] = value;
        }

        /**
         * We could pass "new FormData()" directly but it isn't support in IE browser
         * So passing form data as object.
         */
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    var formParam = new URLSearchParams(convertedJSON);

    // Append action.
    formParam.append('action', action);

    return new Promise(function (resolve, reject) {
        fetch(give_wc_vars.admin_ajax, {
            body: formParam.toString(),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            method: method
        }).then(function (response) {
            if (response.ok) {
                window.location.href = give_wc_vars.checkout_url;
            } else {
                throw new Error(give_wc_vars.checkout_error);
            }
        }).catch(function (err) {
            if (confirm(err)) {
                window.location.href = give_wc_vars.checkout_url;
            }
        });
    });
}

/***/ }),
/* 1 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 *
 *
 * @author Jerry Bendy <jerry@icewingcc.com>
 * @licence MIT
 *
 */

(function(self) {
    'use strict';

    var nativeURLSearchParams = self.URLSearchParams ? self.URLSearchParams : null,
        isSupportObjectConstructor = nativeURLSearchParams && (new nativeURLSearchParams({a: 1})).toString() === 'a=1',
        // There is a bug in safari 10.1 (and earlier) that incorrectly decodes `%2B` as an empty space and not a plus.
        decodesPlusesCorrectly = nativeURLSearchParams && (new nativeURLSearchParams('s=%2B').get('s') === '+'),
        __URLSearchParams__ = "__URLSearchParams__",
        prototype = URLSearchParamsPolyfill.prototype,
        iterable = !!(self.Symbol && self.Symbol.iterator);

    if (nativeURLSearchParams && isSupportObjectConstructor && decodesPlusesCorrectly) {
        return;
    }


    /**
     * Make a URLSearchParams instance
     *
     * @param {object|string|URLSearchParams} search
     * @constructor
     */
    function URLSearchParamsPolyfill(search) {
        search = search || "";

        // support construct object with another URLSearchParams instance
        if (search instanceof URLSearchParams || search instanceof URLSearchParamsPolyfill) {
            search = search.toString();
        }
        this [__URLSearchParams__] = parseToDict(search);
    }


    /**
     * Appends a specified key/value pair as a new search parameter.
     *
     * @param {string} name
     * @param {string} value
     */
    prototype.append = function(name, value) {
        appendTo(this [__URLSearchParams__], name, value);
    };

    /**
     * Deletes the given search parameter, and its associated value,
     * from the list of all search parameters.
     *
     * @param {string} name
     */
    prototype.delete = function(name) {
        delete this [__URLSearchParams__] [name];
    };

    /**
     * Returns the first value associated to the given search parameter.
     *
     * @param {string} name
     * @returns {string|null}
     */
    prototype.get = function(name) {
        var dict = this [__URLSearchParams__];
        return name in dict ? dict[name][0] : null;
    };

    /**
     * Returns all the values association with a given search parameter.
     *
     * @param {string} name
     * @returns {Array}
     */
    prototype.getAll = function(name) {
        var dict = this [__URLSearchParams__];
        return name in dict ? dict [name].slice(0) : [];
    };

    /**
     * Returns a Boolean indicating if such a search parameter exists.
     *
     * @param {string} name
     * @returns {boolean}
     */
    prototype.has = function(name) {
        return name in this [__URLSearchParams__];
    };

    /**
     * Sets the value associated to a given search parameter to
     * the given value. If there were several values, delete the
     * others.
     *
     * @param {string} name
     * @param {string} value
     */
    prototype.set = function set(name, value) {
        this [__URLSearchParams__][name] = ['' + value];
    };

    /**
     * Returns a string containg a query string suitable for use in a URL.
     *
     * @returns {string}
     */
    prototype.toString = function() {
        var dict = this[__URLSearchParams__], query = [], i, key, name, value;
        for (key in dict) {
            name = encode(key);
            for (i = 0, value = dict[key]; i < value.length; i++) {
                query.push(name + '=' + encode(value[i]));
            }
        }
        return query.join('&');
    };

    // There is a bug in Safari 10.1 and `Proxy`ing it is not enough.
    var forSureUsePolyfill = !decodesPlusesCorrectly;
    var useProxy = (!forSureUsePolyfill && nativeURLSearchParams && !isSupportObjectConstructor && self.Proxy)
    /*
     * Apply polifill to global object and append other prototype into it
     */
    self.URLSearchParams = useProxy ?
        // Safari 10.0 doesn't support Proxy, so it won't extend URLSearchParams on safari 10.0
        new Proxy(nativeURLSearchParams, {
            construct: function(target, args) {
                return new target((new URLSearchParamsPolyfill(args[0]).toString()));
            }
        }) :
        URLSearchParamsPolyfill;


    var USPProto = self.URLSearchParams.prototype;

    USPProto.polyfill = true;

    /**
     *
     * @param {function} callback
     * @param {object} thisArg
     */
    USPProto.forEach = USPProto.forEach || function(callback, thisArg) {
        var dict = parseToDict(this.toString());
        Object.getOwnPropertyNames(dict).forEach(function(name) {
            dict[name].forEach(function(value) {
                callback.call(thisArg, value, name, this);
            }, this);
        }, this);
    };

    /**
     * Sort all name-value pairs
     */
    USPProto.sort = USPProto.sort || function() {
        var dict = parseToDict(this.toString()), keys = [], k, i, j;
        for (k in dict) {
            keys.push(k);
        }
        keys.sort();

        for (i = 0; i < keys.length; i++) {
            this.delete(keys[i]);
        }
        for (i = 0; i < keys.length; i++) {
            var key = keys[i], values = dict[key];
            for (j = 0; j < values.length; j++) {
                this.append(key, values[j]);
            }
        }
    };

    /**
     * Returns an iterator allowing to go through all keys of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.keys = USPProto.keys || function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push(name);
        });
        return makeIterator(items);
    };

    /**
     * Returns an iterator allowing to go through all values of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.values = USPProto.values || function() {
        var items = [];
        this.forEach(function(item) {
            items.push(item);
        });
        return makeIterator(items);
    };

    /**
     * Returns an iterator allowing to go through all key/value
     * pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.entries = USPProto.entries || function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push([name, item]);
        });
        return makeIterator(items);
    };


    if (iterable) {
        USPProto[self.Symbol.iterator] = USPProto[self.Symbol.iterator] || USPProto.entries;
    }


    function encode(str) {
        var replace = {
            '!': '%21',
            "'": '%27',
            '(': '%28',
            ')': '%29',
            '~': '%7E',
            '%20': '+',
            '%00': '\x00'
        };
        return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function(match) {
            return replace[match];
        });
    }

    function decode(str) {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    }

    function makeIterator(arr) {
        var iterator = {
            next: function() {
                var value = arr.shift();
                return {done: value === undefined, value: value};
            }
        };

        if (iterable) {
            iterator[self.Symbol.iterator] = function() {
                return iterator;
            };
        }

        return iterator;
    }

    function parseToDict(search) {
        var dict = {};

        if (typeof search === "object") {
            for (var key in search) {
                if (search.hasOwnProperty(key)) {
                    appendTo(dict, key, search[key])
                }
            }

        } else {
            // remove first '?'
            if (search.indexOf("?") === 0) {
                search = search.slice(1);
            }

            var pairs = search.split("&");
            for (var j = 0; j < pairs.length; j++) {
                var value = pairs [j],
                    index = value.indexOf('=');

                if (-1 < index) {
                    appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));

                } else {
                    if (value) {
                        appendTo(dict, decode(value), '');
                    }
                }
            }
        }

        return dict;
    }

    function appendTo(dict, name, value) {
        var val = typeof value === 'string' ? value : (
            value !== null && value !== undefined && typeof value.toString === 'function' ? value.toString() : JSON.stringify(value)
        )

        if (name in dict) {
            dict[name].push(val);
        } else {
            dict[name] = [val];
        }
    }

})(typeof global !== 'undefined' ? global : (typeof window !== 'undefined' ? window : this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {;(function(){var k;function m(a){var b=0;return function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}}}var p="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){a!=Array.prototype&&a!=Object.prototype&&(a[b]=c.value)},q="undefined"!=typeof window&&window===this?this:"undefined"!=typeof global&&null!=global?global:this;function r(){r=function(){};q.Symbol||(q.Symbol=u)}function v(a,b){this.s=a;p(this,"description",{configurable:!0,writable:!0,value:b})}
v.prototype.toString=function(){return this.s};var u=function(){function a(c){if(this instanceof a)throw new TypeError("Symbol is not a constructor");return new v("jscomp_symbol_"+(c||"")+"_"+b++,c)}var b=0;return a}();function w(){r();var a=q.Symbol.iterator;a||(a=q.Symbol.iterator=q.Symbol("Symbol.iterator"));"function"!=typeof Array.prototype[a]&&p(Array.prototype,a,{configurable:!0,writable:!0,value:function(){return x(m(this))}});w=function(){}}
function x(a){w();a={next:a};a[q.Symbol.iterator]=function(){return this};return a}function y(a){var b="undefined"!=typeof Symbol&&Symbol.iterator&&a[Symbol.iterator];return b?b.call(a):{next:m(a)}}var z;if("function"==typeof Object.setPrototypeOf)z=Object.setPrototypeOf;else{var A;a:{var B={v:!0},C={};try{C.__proto__=B;A=C.v;break a}catch(a){}A=!1}z=A?function(a,b){a.__proto__=b;if(a.__proto__!==b)throw new TypeError(a+" is not extensible");return a}:null}var D=z;
function E(){this.h=!1;this.c=null;this.o=void 0;this.b=1;this.m=this.w=0;this.g=null}function F(a){if(a.h)throw new TypeError("Generator is already running");a.h=!0}E.prototype.i=function(a){this.o=a};E.prototype.j=function(a){this.g={A:a,B:!0};this.b=this.w||this.m};E.prototype["return"]=function(a){this.g={"return":a};this.b=this.m};function G(a,b,c){a.b=c;return{value:b}}function H(a){this.C=a;this.l=[];for(var b in a)this.l.push(b);this.l.reverse()}function I(a){this.a=new E;this.D=a}
I.prototype.i=function(a){F(this.a);if(this.a.c)return J(this,this.a.c.next,a,this.a.i);this.a.i(a);return K(this)};function L(a,b){F(a.a);var c=a.a.c;if(c)return J(a,"return"in c?c["return"]:function(d){return{value:d,done:!0}},b,a.a["return"]);a.a["return"](b);return K(a)}I.prototype.j=function(a){F(this.a);if(this.a.c)return J(this,this.a.c["throw"],a,this.a.i);this.a.j(a);return K(this)};
function J(a,b,c,d){try{var e=b.call(a.a.c,c);if(!(e instanceof Object))throw new TypeError("Iterator result "+e+" is not an object");if(!e.done)return a.a.h=!1,e;var f=e.value}catch(g){return a.a.c=null,a.a.j(g),K(a)}a.a.c=null;d.call(a.a,f);return K(a)}function K(a){for(;a.a.b;)try{var b=a.D(a.a);if(b)return a.a.h=!1,{value:b.value,done:!1}}catch(c){a.a.o=void 0,a.a.j(c)}a.a.h=!1;if(a.a.g){b=a.a.g;a.a.g=null;if(b.B)throw b.A;return{value:b["return"],done:!0}}return{value:void 0,done:!0}}
function M(a){this.next=function(b){return a.i(b)};this["throw"]=function(b){return a.j(b)};this["return"]=function(b){return L(a,b)};w();this[Symbol.iterator]=function(){return this}}function N(a,b){var c=new M(new I(b));D&&D(c,a.prototype);return c}
if("undefined"!==typeof Blob&&("undefined"===typeof FormData||!FormData.prototype.keys)){var O=function(a,b){for(var c=0;c<a.length;c++)b(a[c])},P=function(a,b,c){return b instanceof Blob?[String(a),b,void 0!==c?c+"":"string"===typeof b.name?b.name:"blob"]:[String(a),String(b)]},Q=function(a,b){if(a.length<b)throw new TypeError(b+" argument required, but only "+a.length+" present.");},S=function(a){var b=y(a);a=b.next().value;b=b.next().value;a instanceof Blob&&(a=new File([a],b,{type:a.type,lastModified:a.lastModified}));
return a},T="object"===typeof window?window:"object"===typeof self?self:this,U=T.FormData,V=T.XMLHttpRequest&&T.XMLHttpRequest.prototype.send,W=T.Request&&T.fetch,X=T.navigator&&T.navigator.sendBeacon;r();var Y=T.Symbol&&Symbol.toStringTag;Y&&(Blob.prototype[Y]||(Blob.prototype[Y]="Blob"),"File"in T&&!File.prototype[Y]&&(File.prototype[Y]="File"));try{new File([],"")}catch(a){T.File=function(b,c,d){b=new Blob(b,d);d=d&&void 0!==d.lastModified?new Date(d.lastModified):new Date;Object.defineProperties(b,
{name:{value:c},lastModifiedDate:{value:d},lastModified:{value:+d},toString:{value:function(){return"[object File]"}}});Y&&Object.defineProperty(b,Y,{value:"File"});return b}}r();w();var Z=function(a){this.f=Object.create(null);if(!a)return this;var b=this;O(a.elements,function(c){if(c.name&&!c.disabled&&"submit"!==c.type&&"button"!==c.type)if("file"===c.type){var d=c.files&&c.files.length?c.files:[new File([],"",{type:"application/octet-stream"})];O(d,function(e){b.append(c.name,e)})}else"select-multiple"===
c.type||"select-one"===c.type?O(c.options,function(e){!e.disabled&&e.selected&&b.append(c.name,e.value)}):"checkbox"===c.type||"radio"===c.type?c.checked&&b.append(c.name,c.value):(d="textarea"===c.type?c.value.replace(/\r\n/g,"\n").replace(/\n/g,"\r\n"):c.value,b.append(c.name,d))})};k=Z.prototype;k.append=function(a,b,c){Q(arguments,2);var d=y(P.apply(null,arguments));a=d.next().value;b=d.next().value;c=d.next().value;d=this.f;d[a]||(d[a]=[]);d[a].push([b,c])};k["delete"]=function(a){Q(arguments,
1);delete this.f[String(a)]};k.entries=function b(){var c=this,d,e,f,g,h,t;return N(b,function(l){switch(l.b){case 1:d=c.f,f=new H(d);case 2:var n;a:{for(n=f;0<n.l.length;){var R=n.l.pop();if(R in n.C){n=R;break a}}n=null}if(null==(e=n)){l.b=0;break}g=y(d[e]);h=g.next();case 5:if(h.done){l.b=2;break}t=h.value;return G(l,[e,S(t)],6);case 6:h=g.next(),l.b=5}})};k.forEach=function(b,c){Q(arguments,1);for(var d=y(this),e=d.next();!e.done;e=d.next()){var f=y(e.value);e=f.next().value;f=f.next().value;
b.call(c,f,e,this)}};k.get=function(b){Q(arguments,1);var c=this.f;b=String(b);return c[b]?S(c[b][0]):null};k.getAll=function(b){Q(arguments,1);return(this.f[String(b)]||[]).map(S)};k.has=function(b){Q(arguments,1);return String(b)in this.f};k.keys=function c(){var d=this,e,f,g,h,t;return N(c,function(l){1==l.b&&(e=y(d),f=e.next());if(3!=l.b){if(f.done){l.b=0;return}g=f.value;h=y(g);t=h.next().value;return G(l,t,3)}f=e.next();l.b=2})};k.set=function(c,d,e){Q(arguments,2);var f=P.apply(null,arguments);
this.f[f[0]]=[[f[1],f[2]]]};k.values=function d(){var e=this,f,g,h,t,l;return N(d,function(n){1==n.b&&(f=y(e),g=f.next());if(3!=n.b){if(g.done){n.b=0;return}h=g.value;t=y(h);t.next();l=t.next().value;return G(n,l,3)}g=f.next();n.b=2})};Z.prototype._asNative=function(){for(var d=new U,e=y(this),f=e.next();!f.done;f=e.next()){var g=y(f.value);f=g.next().value;g=g.next().value;d.append(f,g)}return d};Z.prototype._blob=function(){for(var d="----formdata-polyfill-"+Math.random(),e=[],f=y(this),g=f.next();!g.done;g=
f.next()){var h=y(g.value);g=h.next().value;h=h.next().value;e.push("--"+d+"\r\n");h instanceof Blob?e.push('Content-Disposition: form-data; name="'+g+'"; filename="'+h.name+'"\r\n',"Content-Type: "+(h.type||"application/octet-stream")+"\r\n\r\n",h,"\r\n"):e.push('Content-Disposition: form-data; name="'+g+'"\r\n\r\n'+h+"\r\n")}e.push("--"+d+"--");return new Blob(e,{type:"multipart/form-data; boundary="+d})};Z.prototype[Symbol.iterator]=function(){return this.entries()};Z.prototype.toString=function(){return"[object FormData]"};
Y&&(Z.prototype[Y]="FormData");if(V){var aa=T.XMLHttpRequest.prototype.setRequestHeader;T.XMLHttpRequest.prototype.setRequestHeader=function(d,e){aa.call(this,d,e);"content-type"===d.toLowerCase()&&(this.u=!0)};T.XMLHttpRequest.prototype.send=function(d){d instanceof Z?(d=d._blob(),this.u||this.setRequestHeader("Content-Type",d.type),V.call(this,d)):V.call(this,d)}}if(W){var ba=T.fetch;T.fetch=function(d,e){e&&e.body&&e.body instanceof Z&&(e.body=e.body._blob());return ba.call(this,d,e)}}X&&(T.navigator.sendBeacon=
function(d,e){e instanceof Z&&(e=e._asNative());return X.call(this,d,e)});T.FormData=Z};
})();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
module.exports = __webpack_require__(7);


/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _giveWcForm = __webpack_require__(8);

var _giveWcForm2 = _interopRequireDefault(_giveWcForm);

var _giveWcHelpers = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Initial load.
document.addEventListener("DOMContentLoaded", function () {

	// IE event supports.
	if (typeof window.CustomEvent !== "function") {
		_giveWcHelpers.CustomEvent.prototype = window.Event.prototype;
		window.CustomEvent = _giveWcHelpers.CustomEvent;
	}

	new _giveWcForm2.default();
});

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _giveWcHelpers = __webpack_require__(0);

var _giveWcAmount = __webpack_require__(9);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * All the actions related to the Give Donation form will be done in this.
 *
 * @since 1.0.0
 */
var Give_WC_Donation_Form = function () {

    /**
     * Constructor.
     */
    function Give_WC_Donation_Form() {
        _classCallCheck(this, Give_WC_Donation_Form);

        // Get WooCommerce panel.
        this.$wcPanel = (0, _giveWcHelpers.gwc_qs)('body.woocommerce-cart, body.woocommerce-checkout');

        // Get the head of the donation form.
        this.$donationHead = 'input[type="checkbox"].give-wc-form-selector, .give-wc-give-form-head,.give-wc-checkbox-row';

        // Get the donation form levels.
        this.$donationLevel = 'input[type="radio"].give-wc-donation-level, select.give-wc-select';

        // Donation form amount field.
        this.$amount_field = 'input.give-wc-amount-field';

        // Get the checkout button.
        this.$checkoutButton = 'a.checkout-button';

        // If we're not the cart/checkout page.
        if (null !== this.$wcPanel && null !== (0, _giveWcHelpers.gwc_qs)('.give_wc_donation_section')) {
            this.bindEvents();
        }

        // Fix cart list when hit back button on checkout page.
        this.fixCartWhenHitBack();
    }

    /**
     * When come back from the checkout page to cart page reset the donation form list.
     *
     * @since 1.0.0
     */


    _createClass(Give_WC_Donation_Form, [{
        key: 'fixCartWhenHitBack',
        value: function fixCartWhenHitBack() {
            if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
                // Get all checkbox.
                var donationCheckboxs = (0, _giveWcHelpers.gwc_qsa)('input.give-wc-form-selector');

                donationCheckboxs.forEach(function (element) {
                    // Uncheck.
                    element.checked = false;

                    var donationRow = (0, _giveWcHelpers.gwc_parent)(element, 'td'),
                        donationOptions = (0, _giveWcHelpers.gwc_qs)('.give-wc-donation-inside', donationRow);

                    donationRow.classList.remove('give-wc-active-row');
                    donationOptions.classList.add('give-wc-hidden');
                });
            }
        }

        /**
         * Bind events callbacks with selectors.
         *
         * @since 1.0.0
         */

    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            var that = this;

            /**
             * Disable the default behaviour of the checkbox and label.
             */
            (0, _giveWcHelpers.gwc_delegate)(that.$wcPanel, '.give-wc-give-form-label input, .give-wc-give-form-label p', 'click', function (e) {
                e.stopPropagation();
            });

            /**
             * Update Cart on click.
             */
            (0, _giveWcHelpers.gwc_delegate)(that.$wcPanel, '.woocommerce-checkout button[name="give_wc_update_donation"]', 'click', function (e) {
                document.body.dispatchEvent(new _giveWcHelpers.CustomEvent('update_checkout')); // Dispatch it.
            });

            /**
             * When amount field updated.
             */
            (0, _giveWcHelpers.gwc_delegate)(that.$wcPanel, that.$amount_field, 'change', function (e) {

                // Set amount.
                var amountField = e.target,
                    amount = new _giveWcAmount.Give_WC_Amount(amountField.value);

                // Format the amount.
                amountField.value = amount.formatAmount();

                var matchLevel = void 0,
                    parentRow = (0, _giveWcHelpers.gwc_parent)(amountField, 'td'),
                    formID = parentRow.getAttribute('data-form_id'),
                    unformatAmount = amount.unFormatAmount();

                // Check min/max amount.
                !new _giveWcAmount.Give_WC_Amount(unformatAmount).verifyAmount(formID) ? amountField.classList.add('give-wc-invalid-amount') : amountField.classList.remove('give-wc-invalid-amount');

                // Get the donation levels.
                var donationLevels = (0, _giveWcHelpers.gwc_qsa)('select.give-wc-select option, input[type="radio"].give-wc-donation-level', parentRow);

                // If donation form has variable prices.
                if (donationLevels.length > 0) {

                    // Go through each of the donation levels.
                    Array.prototype.forEach.call(donationLevels, function (node) {
                        if (unformatAmount == node.getAttribute('data-amount')) {
                            matchLevel = node.value;
                            return;
                        }
                    });

                    // Get the match level.
                    matchLevel = 'undefined' === typeof matchLevel ? 'custom' : matchLevel;

                    // Auto choose the donation level.
                    switch (give_wc_vars.level_display_style) {

                        case 'dropdown':
                            (0, _giveWcHelpers.gwc_qs)('.give-wc-select', parentRow).value = matchLevel;
                            break;
                        case 'radio':
                            (0, _giveWcHelpers.gwc_qs)('.give_wc_level_' + matchLevel, parentRow).checked = true;
                            break;
                    }
                }
            });

            /**
             * Toggle Donation Form options.
             */
            (0, _giveWcHelpers.gwc_delegate)(that.$wcPanel, that.$donationHead, 'click', function (e) {

                // Get the donation row td.
                var selectedHead = e.target,
                    donation_row = (0, _giveWcHelpers.gwc_parent)(selectedHead, 'td'),
                    amount_field = (0, _giveWcHelpers.gwc_qs)('.give-amount-top', donation_row);

                // Add/Remove class.
                donation_row.classList.toggle('give-wc-active-row');

                if ('INPUT' !== selectedHead.nodeName) {

                    // Donation form checkbox.
                    var form_checkbox = (0, _giveWcHelpers.gwc_qs)('input[type="checkbox"].give-wc-form-selector', donation_row);

                    // Toggle the checkbox.
                    form_checkbox.checked = form_checkbox.checked ? false : true;
                }

                // Toggle the donation option.
                (0, _giveWcHelpers.gwc_find)(donation_row, 'give-wc-donation-inside').classList.toggle('give-wc-hidden');

                // Verify amount.
                new _giveWcAmount.Give_WC_Amount(amount_field.value).verifyAmount(donation_row.getAttribute('data-form_id'));
            });

            /**
             * When Donation level changed.
             */
            (0, _giveWcHelpers.gwc_delegate)(that.$wcPanel, that.$donationLevel, 'change', function (e) {
                e.preventDefault();

                var currentLevel = e.target,
                    parentRow = (0, _giveWcHelpers.gwc_parent)(currentLevel, 'td'),
                    formInsider = (0, _giveWcHelpers.gwc_find)(parentRow, 'give-wc-donation-inside'),
                    amountField = (0, _giveWcHelpers.gwc_qs)('.give-amount-top', parentRow);

                // Get the donation amount and price Id.
                var donationAmount = 'SELECT' === currentLevel.nodeName ? currentLevel.options[currentLevel.selectedIndex].getAttribute('data-amount') : currentLevel.getAttribute('data-amount');
                var priceID = 'SELECT' === currentLevel.nodeName ? currentLevel.options[currentLevel.selectedIndex].value : currentLevel.value;

                // Set the formatted value.
                amountField.value = '' !== donationAmount ? new _giveWcAmount.Give_WC_Amount(donationAmount).formatAmount() : 0.00;

                if ('custom' === priceID) {
                    // Highlights amount field for better UI.
                    amountField.setSelectionRange(0, 5);
                    amountField.focus();
                }

                // Update the text of the amount span.
                if ((0, _giveWcHelpers.gwc_qs)('.give-wc-form-amount', formInsider)) {
                    (0, _giveWcHelpers.gwc_qs)('.give-wc-form-amount', formInsider).innerText = new _giveWcAmount.Give_WC_Amount(donationAmount, { symbol: give_wc_vars.currency_settings.symbol }).formatAmount();
                }

                !new _giveWcAmount.Give_WC_Amount(amountField.value).verifyAmount(parentRow.getAttribute('data-form_id')) ? amountField.classList.add('give-wc-invalid-amount') : amountField.classList.remove('give-wc-invalid-amount');
            });

            /**
             * When click on the "Proceed to checkout" add selected donation to the WC Cart.
             *
             * @since 1.0.0
             */
            (0, _giveWcHelpers.gwc_delegate)(that.$wcPanel, that.$checkoutButton, 'click', function (e) {
                e.preventDefault();
                (0, _giveWcHelpers.gwc_updateCartByCheckout)('give_wc_process_donations', (0, _giveWcHelpers.gwc_qs)('.woocommerce-cart-form'));
            });
        }
    }]);

    return Give_WC_Donation_Form;
}();

exports.default = Give_WC_Donation_Form;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Give_WC_Amount = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _giveWcHelpers = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This class is for getting, formatting and unformatting the
 * amount value.
 *
 * @since 1.0.0
 */
var Give_WC_Amount = exports.Give_WC_Amount = function () {

    /**
     * Get and set the amount, args and form selector.
     *
     * @since 1.0.0
     *
     * @param {double} amount
     * @param {Object} args
     * @param {Object} form
     */
    function Give_WC_Amount(amount, args, form) {
        _classCallCheck(this, Give_WC_Amount);

        this.amount = amount || 0.00;
        this.form = form || {};

        // Set default values if not passed.
        this.args = Object.assign({
            symbol: '',
            position: give_wc_vars.currency_settings.currency_position,
            decimal: give_wc_vars.currency_settings.decimal_sep,
            thousand: give_wc_vars.currency_settings.thousand_sep,
            precision: parseInt(give_wc_vars.currency_settings.decimal_numbers),
            currency: give_wc_vars.currency_settings.currency
        }, args);

        // Make sure amount we set un-formatted amount to amount property.
        this.amount = this.unFormatAmount();
    }

    /**
     * Get the Donation Form amount.
     *
     * @since 1.0.0
     *
     * @param {int} form_id
     */


    _createClass(Give_WC_Amount, [{
        key: 'getAmount',
        value: function getAmount(form_id) {

            // Get the amount field.
            var amount_field = (0, _giveWcHelpers.gwc_qs)('#give-wc-form-' + $form_id + ' input#give-amount').value;

            // Return amount.
            return amount_field.value || false;
        }

        /**
         * Get the format amount.
         *
         * @since 1.0.0
         */

    }, {
        key: 'formatAmount',
        value: function formatAmount() {
            return Give.fn.formatCurrency(this.amount, this.args, this.form);
        }

        /**
         * Unformat the amount value and return.
         *
         * @since 1.0.0
         * @param {string} decimal_separator
         */

    }, {
        key: 'unFormatAmount',
        value: function unFormatAmount(decimal_separator, amount) {
            var decimal = decimal_separator || this.args.decimal;
            var currentAmount = amount || this.amount;

            return Give.fn.unFormatCurrency(currentAmount, decimal);
        }

        /**
         * Verify the passed value for min/max amount.
         *
         * @since 1.0.0
         * @param {int} form_id
         */

    }, {
        key: 'verifyAmount',
        value: function verifyAmount(form_id) {

            // Get the Minimum and Maximum Amount.
            var currentAmount = this.unFormatAmount(this.args.decimal, this.amount),
                min_amount = parseFloat((0, _giveWcHelpers.gwc_attr)(form_id, 'minimum')),
                max_amount = parseFloat((0, _giveWcHelpers.gwc_attr)(form_id, 'maximum')),
                flag = true;

            // Get the buttons.
            var btn_on_cart = (0, _giveWcHelpers.gwc_qs)('form.woocommerce-cart-form button[name="update_cart"],form.woocommerce-cart-form *[name="update_cart"] '),
                btn_on_checkout = (0, _giveWcHelpers.gwc_qs)('form.woocommerce-checkout button#give_wc_update_donation');

            // Get the donation form row.
            var formRow = (0, _giveWcHelpers.gwc_qs)('.give-wc-give-form-row[data-form_id="' + form_id + '"]');

            // Get the amount field.
            var amountField = (0, _giveWcHelpers.gwc_qs)('.give-wc-amount-field', formRow);

            // Get the tooltip.
            var tooltip = (0, _giveWcHelpers.gwc_parent)(amountField, 'span');

            // Check minimum/maximum validation.
            if (currentAmount < min_amount || currentAmount > max_amount) {
                var minMaxAmount = currentAmount < min_amount ? formRow.dataset.minimum : formRow.dataset.maximum,
                    formatAmount = new Give_WC_Amount(minMaxAmount, { symbol: give_global_vars.currency_sign }).formatAmount(currentAmount),
                    errorMessage = currentAmount < min_amount ? give_global_vars.bad_minimum : give_global_vars.bad_maximum;

                tooltip.setAttribute('aria-label', errorMessage + ' ' + formatAmount);

                // Block the buttons.
                if (null !== btn_on_cart) {
                    btn_on_cart.setAttribute('disabled', '');
                    tooltip.classList.remove('give_wc_hide_tooltip');
                }

                if (null !== btn_on_checkout) {
                    btn_on_checkout.setAttribute('disabled', '');
                    tooltip.classList.remove('give_wc_hide_tooltip');
                }

                flag = false;
            }

            // Un-block buttons.
            if (flag) {

                setTimeout(function () {
                    // Get all the fields.
                    var invalidAmountFields = (0, _giveWcHelpers.gwc_qsa)('.give-wc-invalid-amount'),
                        isInvalidAnyForm = false;

                    if (invalidAmountFields) {

                        Array.prototype.forEach.call(invalidAmountFields, function (element) {
                            var parentRow = (0, _giveWcHelpers.gwc_parent)(element, 'td'),
                                checkbox = (0, _giveWcHelpers.gwc_qs)('input[type="checkbox"].give-wc-form-selector', parentRow);

                            if (checkbox.checked) {
                                isInvalidAnyForm = true;
                            }
                        });
                    }

                    if (!isInvalidAnyForm) {
                        if (null !== btn_on_cart) {
                            btn_on_cart.removeAttribute('disabled');
                            tooltip.classList.add('give_wc_hide_tooltip');
                        }

                        if (null !== btn_on_checkout) {
                            btn_on_checkout.removeAttribute('disabled');
                            tooltip.classList.add('give_wc_hide_tooltip');
                        }
                    }
                }, 100);
            }

            return flag;
        }
    }]);

    return Give_WC_Amount;
}();

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/frontend.js